<template>
  <div class="select-wrapper">
    <div class="select-display" @click="toggleDropdown">
      {{ selected || __('Selecione o filtro') }}
      <img
        src="/build/icons/chevron-down.svg"
        alt="seta para baixo"
        class="chevron-down-icon"
      />
    </div>

    <div class="select-dropdown-wrapper" ref="dropdownWrapper">
      <div class="select-dropdown" v-if="showDropdown" ref="dropdown" :style="{ top: dropdownTop + 'px' }">
        <div class="select-search-container">
          <div class="input-wrapper">
            <input type="text" class="select-search" v-model="search" :placeholder="__('Pesquisar filtro')" @click.stop />
            <img
              src="/build/icons/search-icon.svg"
              width="16"
              height="16"
              alt="Lupa do campo de pesquisa"
              class="search-icon"
            />
          </div>
        </div>
        <div class="select-options" ref="selectOptions" :style="{ maxHeight: noResults ? '120px' : (selectOptionsHeight + 'px') }">
          <div v-if="filteredStandardFilters.length">
            <div class="filter-type-label">
              <div>{{ __('Filtros padrão') }}</div>
            </div>
            <div class="select-option" v-for="(filter, index) in filteredStandardFilters" :key="index" @click="selectOption(filter)">
              {{ filter.description }}
            </div>
          </div>
          <div v-if="filteredCustomFilters.length">
            <div class="filter-type-label">
              <div>{{ __('Filtros customizados') }}</div>
            </div>
            <div class="select-option" v-for="(filter, index) in filteredCustomFilters" :key="index" @click="selectOption(filter)">
              {{ filter.description }}
            </div>
          </div>
          <div v-if="noResults" class="no-results">
            {{ __('Nenhum filtro encontrado com este nome.') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['filters', 'removedFilters', 'value', 'rows'],

  data() {
    return {
      selected: '',
      showDropdown: false,
      search: '',
      standardFilters: [],
      customFilters: [],
      inputFilter: {},
      dropdownTop: 0,
      selectOptionsHeight: 400
    };
  },

  mounted() {
    this.inputFilter = this.getFilter(this.value);
    this.selected = this.inputFilter.description || '';
    document.addEventListener('click', this.handleClickOutside);
    window.addEventListener('resize', this.updateDropdownWidth);
    this.$el.closest('.lead-filter').addEventListener('scroll', this.handleParentScroll);
  },

  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
    document.removeEventListener('resize', this.updateDropdownWidth);
    const leadFilterElement = this.$el.closest('.lead-filter');
    if (leadFilterElement) {
      leadFilterElement.removeEventListener('scroll', this.handleParentScroll);
    }
  },

  watch: {
    value(input) {
      this.inputFilter = this.getFilter(this.value);
      this.selected = this.inputFilter.description || '';
    },

    filters: {
      handler(newFilters) {
        this.standardFilters = newFilters.filter(filter => filter.category !== 'Campo customizado');
        this.customFilters = newFilters.filter(filter => filter.category === 'Campo customizado');
        this.sortFilters();
      },
      immediate: true,
    }
  },

  computed: {
    filteredStandardFilters() {
      return this.standardFilters.filter(filter => 
        filter.description.toLowerCase().includes(this.search.toLowerCase())
      );
    },

    filteredCustomFilters() {
      return this.customFilters.filter(filter => 
        filter.description.toLowerCase().includes(this.search.toLowerCase())
      );
    },

    noResults() {
      return !this.filteredStandardFilters.length && !this.filteredCustomFilters.length;
    }
  },

  methods: {
    toggleDropdown() {
      if (!this.showDropdown) {
        this.updateDropdownHeight();
      }

      this.showDropdown = !this.showDropdown;
      this.$nextTick(() => {
        if (this.showDropdown) {
          this.updateDropdownWidth();
          this.updateDropdownPosition();
        }
      });
    },

    updateDropdownHeight() {
      const dropdownWrapper = this.$refs.dropdownWrapper;
      const dropdownRect = dropdownWrapper.getBoundingClientRect();
      const dropdownTop = dropdownRect.top;
      const windowHeight = window.innerHeight;
      const availableHeight = windowHeight - dropdownTop;

      const maxDropdownHeight = 480;
      const headerHeight = 80;

      if (availableHeight < maxDropdownHeight) {
        this.selectOptionsHeight = availableHeight - (headerHeight + 10);
      }

      this.dropdownTop = dropdownRect.height + 4;
    },

    updateDropdownWidth() {
      const wrapperWidth = this.$el.getBoundingClientRect().width;
      if (this.$refs.dropdown) {
        this.$refs.dropdown.style.width = `${wrapperWidth}px`;
      }
    },

    updateDropdownPosition() {
      const selectWrapperRect = this.$el.getBoundingClientRect();
      this.dropdownTop = selectWrapperRect.height + selectWrapperRect.top + 4;
    },

    handleClickOutside(event) {
      const path = event.path || (event.composedPath && event.composedPath());
      if (!path.includes(this.$el)) {
        this.showDropdown = false;
      }
    },
    
    handleParentScroll() {
      this.showDropdown = false;
    },

    selectOption(option) {
      this.selected = option.description;
      this.showDropdown = false;
      this.$emit('input', option.filter);
      Bus.$emit('filterChanged', option, this.inputFilter);
    },

    getFilter(filter) {
      return this.filters.find((object) => object.filter.toString() === filter.toString())
          || this.removedFilters.find((object) => object.filter.toString() === filter.toString())
          || {};
    },

    selectedFilter(filter) {
      if (this.value) {
        return filter.filter.toString() === this.value.toString();
      }
      return false;
    },

    isStandard(filter) {
      return filter.category !== 'Campo customizado';
    },

    sortFilters() {
      this.standardFilters.sort((a, b) => a.description.localeCompare(b.description));
      this.customFilters.sort((a, b) => a.description.localeCompare(b.description));
    }
  }
}
</script>

<style scoped>
.select-wrapper {
  position: relative;
  background-color: #fff;
  border-radius: 8px;
  outline: 1px solid #d1d1d1;
  height: 52px;
  display: flex;
  align-items: center;
}

.select-display {
  color: #71767d;
  font-family: 'Montserrat';
  font-size: 1rem;
  font-weight: 500;
  line-height: 150%;
  padding: 0 12px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.select-dropdown-wrapper {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin-top: 4px;
  z-index: 3000;
}

.select-dropdown {
  position: fixed;
  border-radius: 14px;
  border: 1px solid #ccc;
  background: #fff;
  z-index: 3000;
  max-height: 480px;
  overflow: hidden;
  width: 100%;
}

.select-search-container {
  padding: 16px;
  position: relative;
}

.select-search {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #ced4da;
  display: flex;
  height: 48px;
  padding: 8px 16px;
  align-items: center;
  border-radius: 8px;

  color: #71767D;
  font-family: 'Inter';
  font-size: 16px;
  line-height: 150%;
}

.search-icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 32px;
}

.select-options {
  overflow-y: scroll;
  max-height: 400px;
}

.select-option {
  color: #242424;
  font-family: 'Inter';
  font-size: 16px;
  line-height: 150%;
  padding: 4px 0 4px 16px;
  margin: 4px 0 4px 0;
  width: 100%;
  box-sizing: border-box;
}

.select-option:hover {
  background-color: #f0f0f0;
}

.filter-type-label {
  color: #AAAAAB;
  font-family: 'Inter';
  font-size: 16px;
  font-weight: 700;
  line-height: 150%;
  padding: 4px 4px 4px 16px;

  div {
    border-bottom: 1px solid #D1D1D1;
  }
}

.no-results {
  color: #71767D;
  font-family: 'Inter';
  font-size: 16px;
  line-height: 150%;
  padding: 48px 4px 48px 0;
  text-align: center;
}
</style>